import { Control } from 'superlikers-dynamic-forms'
import { Field } from '@superlikers/microsites-api'

export function formFieldsAdapter(fields: Field[] | null | undefined): Control[] {
  return (fields ?? []).filter(field => field._type !== 'HiddenField').map(toControl)
}

function toControl(field: Field): Control {
  const label = field.label || field.name
  const validators = {
    ...(field.required_field ? { required: true } : {}),
    ...(field._type === 'UserEmailField' ? { email: true } : {})
  }

  // `helpText` y `value` no aceptan null en los formularios dinámicos.
  const base = { name: field.name, label, helpText: field.help_text ?? undefined, validators, value: field.default_value ?? undefined }
  const options = (field.choices ?? []).map(choice => ({ label: choice.label, value: choice.value }))

  switch (field._type) {
    case 'SelectField':
      return { ...base, controlType: 'select', options }
    case 'CheckBoxGroupField':
      return { ...base, controlType: 'checkbox-group', options }
    case 'CheckBoxField':
      return { ...base, controlType: 'checkbox', value: field.default_value === 'true' }
    case 'UserEmailField':
      return { ...base, controlType: 'input', type: 'email' }
    case 'PasswordField':
      return { ...base, controlType: 'input', type: 'password' }
    case 'PhoneField':
      return { ...base, controlType: 'input', type: 'tel' }
    default:
      return { ...base, controlType: 'input', type: 'text' }
  }
}
